import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const pageNames = {
  "/": "Impact Technologies | Robotics, AI Labs, Automation & Technical Training",
  "/about": "About Impact Technologies",
  "/training": "Robotics & Technical Training Programs",
  "/labs": "Robotics & AI Lab Setup for Schools and Colleges",
  "/automation": "Industrial & Process Automation Solutions",
  "/projects": "Technology Projects & Solutions",
  "/products": "Technology Products & Robotics Kits",
};

export default function StructuredData() {
  const { pathname } = useLocation();

  useEffect(() => {
    const id = "impact-technologies-structured-data";
    let script = document.getElementById(id);
    if (!script) {
      script = document.createElement("script");
      script.id = id;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: pageNames[pathname] || pageNames["/"],
      url: `https://impactinnovate.com${pathname === "/" ? "/" : pathname}`,
      isPartOf: { "@type": "WebSite", name: "Impact Technologies", url: "https://impactinnovate.com/" },
    });
  }, [pathname]);

  return null;
}
